// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__ylZCL","tabActive":"styles_tabActive__d_8zo styles_tab__ylZCL"};